function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_3366_2157)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.7066 55.576L21.7719 41.6412C19.0159 38.8852 17.139 35.3738 16.3786 31.5511C15.6183 27.7284 16.0086 23.7661 17.5001 20.1652C18.9917 16.5643 21.5175 13.4865 24.7582 11.3211C27.999 9.15577 31.809 8 35.7066 8C39.6042 8 43.4143 9.15577 46.655 11.3211C49.8957 13.4865 52.4216 16.5643 53.9131 20.1652C55.4047 23.7661 55.795 27.7284 55.0346 31.5511C54.2742 35.3738 52.3974 38.8852 49.6414 41.6412L35.7066 55.576Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.5201 39.5199L35.7066 51.3333L23.8932 39.5199C21.5567 37.1834 19.9656 34.2066 19.321 30.9658C18.6764 27.7251 19.0073 24.3659 20.2717 21.3132C21.5362 18.2605 23.6776 15.6513 26.4249 13.8156C29.1723 11.9798 32.4024 11 35.7066 11C39.0109 11 42.2409 11.9798 44.9883 13.8156C47.7357 15.6513 49.877 18.2605 51.1415 21.3132C52.406 24.3659 52.7369 27.7251 52.0922 30.9658C51.4476 34.2066 49.8565 37.1834 47.5201 39.5199ZM35.7066 35.1316C37.6759 35.1316 39.5645 34.3493 40.957 32.9569C42.3495 31.5644 43.1318 29.6757 43.1318 27.7065C43.1318 25.7372 42.3495 23.8486 40.957 22.4561C39.5645 21.0636 37.6759 20.2813 35.7066 20.2813C33.7373 20.2813 31.8487 21.0636 30.4562 22.4561C29.0638 23.8486 28.2815 25.7372 28.2815 27.7065C28.2815 29.6757 29.0638 31.5644 30.4562 32.9569C31.8487 34.3493 33.7373 35.1316 35.7066 35.1316Z",
  fill: "inherit"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_3366_2157",
  x: -4,
  y: 0,
  width: 80,
  height: 80,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.00392157 0 0 0 0 0 0 0 0 0 0.156863 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3366_2157"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3366_2157",
  result: "shape"
})));

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.6ba6ad5b.svg";
export { ForwardRef as ReactComponent };